<template>
    <div class="companies-selector-block" >
        <div class="content text-center">
            <h3>Yritykset</h3>
        </div>

        <select v-model="accountIdData" v-on:change="emitChange" style="width: 100%">
            <option disabled value=""></option>
            <option v-for="account in sortedAccounts"
                    :id="account.accountToken"
                    :name="account.organizationId"
                    v-bind:value="{
                        accountToken: account.accessToken,
                        role: account.role,
                        organizationId: account.organizationId
                    }">
                {{ account.organizationName }}
            </option>
        </select>
    </div>
</template>

<script>
    import { FoxEnvs } from '../../service/foxeriot_environments';
    import axios from 'axios';
    import EventBus from '../../service/EventBus';

    const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    export default {
        name: 'CompanyList',
        data() {
            return {
                accounts: {},
                accountToken: null,
                accountIdData: null,
            }
        },
        computed: {
            sortedAccounts: function() {
                function compare(a,b) {
                    return a.organizationName > b.organizationName ? 1 : -1;
                }
                if (this.accounts.roles) {
                    return this.accounts.roles.sort(compare)
                } else {
                    return false;
                }
            }
        },
        mounted() {
            this.getAccounts();
        },
        methods: {
            getAccounts: function () {
                axios.get(FoxEnvs.prod.baseUrl + '/api/v1/get-account', {
                    headers: {
                        'Authorization': 'Bearer ' + this.$auth.getAuthToken()
                    }
                })
                    .then( (response) => {
                        this.setAccounts(response.data.data[0])
                    }).catch( (error) => {
                    console.log(error);
                })
            },
            setAccounts: function(data) {
                this.accounts = data

                let validRoles = ['corporate-admin', 'corporate-user'];
                this.accounts.roles = this.accounts.roles.filter( role => {
                    return validRoles.includes(role.role);
                })



                this.saveThemes(this.accounts);
            },
            saveThemes: function(accounts) {
                if (accounts) {

                    Object.keys(accounts.roles).map(function(key) {
                        let account = accounts.roles[key]
                        axios.get(FoxEnvs.prod.baseUrl + '/api/v1/get-organizations', {
                            headers: {
                                'Authorization': 'Bearer ' + account.accessToken
                            }
                        })
                        .then( (response) => {
                            localStorage.setItem('organizationThemes', JSON.stringify(response.data.data))
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                        return true
                    });
                }
            },
            setTheme: function(account) {
                let orgThemes = JSON.parse(localStorage.getItem('organizationThemes'))
                let theme = orgThemes.find(i => i.name === account.organizationName)
                if (theme) {
                    this.$store.dispatch('changeTheme', { theme: theme })
                }

            },
            emitChange: function (e) {
                this.accountToken = this.accountIdData.accountToken;
                this.$auth.setAuthToken(this.accountToken);

                if (this.accounts) {
                    let account = this.accounts.roles.find(i => (
                            i.role === this.accountIdData.role &&
                            i.organizationId === this.accountIdData.organizationId
                        )
                    )
                    if (account) {
                        this.setTheme(account);
                    }
                    this.$store.commit('clearDevices');
                    EventBus.$emit('accountToken', this.accountToken);
                }
            }
        }
    }
</script>

<style scoped>
    label {
        display: block;
    }
    input[type="radio"] + span {
        display: block;
        color: white;
        background: transparent;
        border: 0;
        padding: 0.25em 0.5em;
        font-size: 15px;
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
    }
    input[type="radio"] + span:hover {
        cursor: pointer;
    }
    input[type="radio"] {
        visibility: hidden;
        position: fixed;
        left: -9999px;
    }
    input[type="radio"]:checked + span {
        background: rgba(255,255, 255, 0.25);
    }
    .content.text-center {
        text-align: center;
    }
    .content.text-center h3 {
        color: white;
        margin-top: 0;
        margin-bottom: 0;
    }
    .companies-selector-block {
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/app/Main/components/CompanyList.vue